import { commonAPI } from '@redux/api/common.api'
import { URLS } from '@constants'
import { MobileApp } from '@mobileTypes'

type GETMobileAppsParams = {
  searchPattern?: string
  sort?: string
}

export const mobileAppApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllMobileApps: build.query<MobileApp[], GETMobileAppsParams | void>({
      query: params => ({
        url: URLS.MOBILE_CFG + '/app',
        params: {
          searchPattern: params?.searchPattern,
          sort: params?.sort,
        },
      }),
      providesTags: ['AllMobileApps'],
    }),

    fetchMobileAppById: build.query<MobileApp, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/app/id/${id}`,
      }),
      providesTags: ['SingleMobileApp'],
    }),

    createMobileApp: build.mutation<MobileApp, Omit<MobileApp, 'id' | 'createdAt' | 'updatedAt'>>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/app',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileApps'],
    }),

    updateMobileApp: build.mutation<MobileApp, MobileApp>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/app',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileApps', 'SingleMobileApp'],
    }),

    deleteMobileApp: build.mutation<void, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/app/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllMobileApps'],
    }),

    copyMobileApp: build.mutation<MobileApp, { id: string; name: string; internalId: string }>({
      query: body => ({
        url: URLS.MOBILE_CFG + '/app/copy',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllMobileApps'],
    }),

    fetchAssembledMobileAppConfig: build.query<any, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/app/id/${id}/config`,
      }),
    }),
  }),
})

export const {
  useFetchAllMobileAppsQuery,
  useFetchMobileAppByIdQuery,
  useCreateMobileAppMutation,
  useUpdateMobileAppMutation,
  useDeleteMobileAppMutation,
  useCopyMobileAppMutation,
  useLazyFetchAssembledMobileAppConfigQuery,
} = mobileAppApi
